import { render, staticRenderFns } from "./CurrentUserGroupsStatsModal.vue?vue&type=template&id=112a797a&"
import script from "./CurrentUserGroupsStatsModal.vue?vue&type=script&lang=js&"
export * from "./CurrentUserGroupsStatsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports